import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import progressAnimation from '@/assets/animation/save_loader.json';
import { ReactComponent as EditIcon } from '@/assets/img/edit-icon.svg';
import { ReactComponent as AddIcon } from '@/assets/img/add-icon.svg';
import { ReactComponent as MoreIcon } from '@/assets/img/more-icon.svg';
import { useGetPetsList } from '../api/getPetsList';
import { useAuth } from '@/lib/auth';
import Lottie from 'lottie-react';
import noDataAnimation from '@/assets/animation/no_data.json';
import ReactPaginate from 'react-paginate';
import { ReactComponent as UserIcon } from '@/assets/img/user-flat.svg';
import { Pet } from '../types';
import '../components/css/PetProfile.scss';
import PlusIcon from '@/assets/img/plus-icon.svg';
import PetsIcon from '@/assets/img/pets.png';

export const PetsListPage = () => {
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 20;
  const [selectedPage, setSelectedPage] = useState(1);
  const { user } = useAuth();
  const useGetEventsMutation = useGetPetsList();
  const [petsList, setPetsList] = useState<Pet[]>();
  const [isPast, setPast] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [addNewPet, setAddnewPet] = useState(false);
  const [editPetId, setEditPet] = useState<Pet>();

  useEffect(() => {
    fetchEvents(false);
  }, [selectedPage]);

  const fetchEvents = async (isPast: boolean) => {
    const res = await useGetEventsMutation.mutateAsync({
      businessId: user?.businessId,
      page: selectedPage,
      perPage: perPage,
      isPast: isPast,
    });
    setTotalPages(res.totalPages);
    setPetsList(res.list);
  };

  const handlePageClick = async (event: any) => {
    setSelectedPage(event.selected + 1);
  };

  return (
    <>
      <div className="page-title margin-20">My Pets</div>
      {/* <div className="add-cal-btn margin-50">
        <button
          onClick={() => {
            setEditPet(undefined);
            setOpenEditModal(true);
            setAddnewPet(true);
          }}
          className="traparant-btn inline-flex items-center float-right-btn"
        >
          <img src={PlusIcon} className="plus-icon" />
          <span> {'Add Pet'}</span>
        </button>
      </div> */}
      {useGetEventsMutation.isLoading ? (
          <>
            <Lottie className="progress-animation enduser-pop-loader-btn pets-list-progress" animationData={progressAnimation} />
          </>
        ) : (
        <></>
        )}

      {/* {petsList && petsList.length < 1 && !useGetEventsMutation.isLoading ? (
        <div>
          <div className="h-full w-full flex items-center justify-center">
            <Lottie className="h-40 w-40" animationData={noDataAnimation} />
          </div>
          <div className="upcoming-sub-title">No Pets Added.</div>
        </div>
      ) : null} */}
      <div className="pets-list-div">
        {petsList &&
          petsList.length > 0 && !useGetEventsMutation.isLoading &&
          petsList.map((item, index) => {
            return (
              <div className="wrapper">
                {/* <div className="top-icons">
                  <MoreIcon className="thumbnail add-icon" />
                </div> */}

                <div className="profile">
                  {item?.petsImageUrl || item.petsImageUrl == '' ? (
                    <img src={item?.petsImageUrl} className="thumbnail" />
                  ) : (
                    <img src={PetsIcon} className="profile-image" />
                  )}

                  <h3 className="name">{`${item?.name}`}</h3>
                  <p className="description">Birthdate : {item?.dateOfBirth}</p>
                  <p className="description">Gender : {item?.gender}</p>
                  {item?.breed && <p className="description">Breed : {`${item?.breed}`}</p>}
                </div>
                <button
                  type="button"
                  onClick={() => {
                    // setEditPet(item);
                    // setOpenEditModal(true);
                    navigate(`/pet-profile`,{
                      state : item.id
                    });
                  }}
                  className="btn"
                >
                  Edit Profile
                </button>
              </div>
            );
          })}

        {!useGetEventsMutation.isLoading && <div className="wrapper">
          <div
            className="profile add-icon-div"
            onClick={() => {
              setEditPet(undefined);
              setOpenEditModal(true);
              setAddnewPet(true);
            }}
          >
            <AddIcon className="thumbnail add-icon" />
            <h3 className="name">Add Pet</h3>
          </div>
        </div>}
      </div>
      {totalPages > 1 && (
        <div className="pagination-outer">
          <ReactPaginate
            nextLabel="Next"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={totalPages}
            previousLabel="Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
      )}

      {/* {openEditModal && (
        <AddPetProfile
          onSuccess={async () => {
            setOpenEditModal(false);
            setAddnewPet(false);
            setEditPet(undefined);
            fetchEvents(false);
          }}
          onBackClick={() => {
            setOpenEditModal(false);
            setAddnewPet(false);
            setEditPet(undefined);
            //fetchEvents(false);
          }}
          isOpen={true}
          fromMenu={false}
          editPetId={editPetId}
          addNewPet={addNewPet}
        />
      )} */}
    </>
  );
};
